import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "../features/counterSlice";
import uiReducer from "../features/uiSlice";
import domainsReducer from "../features/domainsSlice";
import tutorialsReducer from "../features/tutorialsSlice";
import projectsReducer from "../features/projectsSlice";
import editProjectReducer from "../features/editProjectSlice";
import viewProjectReducer from "../features/viewProjectSlice";
import editTutorialReducer from "../features/editTutorialSlice";
import myAgencyReducer from "../features/myAgencySlice";
import editAgencyReducer from "../features/editAgencySlice";
import userReducer from '../features/userSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    ui: uiReducer,
    domains: domainsReducer,
    tutorials: tutorialsReducer,
    projects: projectsReducer,
    editProject: editProjectReducer,
    viewProject: viewProjectReducer,
    editTutorial: editTutorialReducer,
    myAgency: myAgencyReducer,
    editAgency: editAgencyReducer,
    user: userReducer
  },
});
